const {
	REACT_APP_NAME,
	REACT_APP_ENDPOINT,
	REACT_APP_REGION,
	REACT_APP_BUCKET,
	REACT_APP_IDENTITY_POOL_ID,
	REACT_APP_USER_POOL_ID,
	REACT_APP_USER_POOL_WEB_CLIENT_ID,
} = process.env;

const awsConfig = {
	Auth: {
		identityPoolId: REACT_APP_IDENTITY_POOL_ID,
		region: REACT_APP_REGION,
		userPoolId: REACT_APP_USER_POOL_ID,
		userPoolWebClientId: REACT_APP_USER_POOL_WEB_CLIENT_ID,
	},
	API: {
		endpoints: [
			{
				name: REACT_APP_NAME,
				endpoint: REACT_APP_ENDPOINT,
				region: REACT_APP_REGION,
			},
		],
	},
	Storage: {
		AWSS3: {
			bucket: REACT_APP_BUCKET,
			region: REACT_APP_REGION,
		},
	},
};

export default awsConfig;
